import { ChangeDetectionStrategy, Component, EventEmitter, Injector, Input, Output, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ValueAccessor } from '../../value-accessor/value-accessor';

@Component({
    selector: 'sera-input-text',
    templateUrl: './sera-input-text.component.html',
    styleUrls: ['./sera-input-text.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SeraInputTextComponent),
            multi: true
        }
    ],
    standalone: false
})
export class SeraInputTextComponent extends ValueAccessor<string> {
    //Default is enabled.
    @Input()
    isDisabled: boolean = false;

    //Default is not required.
    @Input()
    required: boolean = false;

    @Input()
    typeOfInput: string = 'text';

    @Input()
    readOnly: boolean = false;

    @Input()
    manuallyEditable: boolean = true;

    //Matches the label to the input.
    @Input()
    inputId!: string;

    @Input() //*
    name!: string;

    @Input()
    placeholder: string = '';

    @Input()
    style!: {};

    @Input()
    autoWidth: boolean = false;

    //Is empty by default: if anything else, then the styleClass changes to support icons. Icon will be on the left by default.
    @Input()
    icon: string | undefined;

    @Input()
    iconSide: string = 'right';

    @Input()
    label: string | undefined;

    @Input()
    inputStyle: string = '';

    @Input()
    inputClass: string = '';

    @Output() inputChanged = new EventEmitter<string>();

    @Output() inputBlur = new EventEmitter<string>();

    constructor(injector: Injector) {
        super(injector);
    }

    iconSideClass(): string {
        if (this.icon) {
            return this.iconSide === 'left' ? ' p-input-icon-left ' : ' p-input-icon-right ';
        }
        return '';
    }
}
